import { render } from "./DetailTargetSpcList.vue?vue&type=template&id=aab756c4"
import script from "./DetailTargetSpcList.vue?vue&type=script&lang=js"
export * from "./DetailTargetSpcList.vue?vue&type=script&lang=js"
script.render = render

export default script